import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class FopInfoBox extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onDismiss: PropTypes.func.isRequired,
  };

  render() {
    const { children, className, onDismiss } = this.props;
    return (
      // We can disable these rules as a valid close button is inside. This is a helper for mouse users only.
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <div
        className={className}
        onClick={onDismiss}
      >
        <button
          className="closeButton"
          onClick={onDismiss}
          aria-label="Close"
        />
        {children}
      </div>
    );
  }
}
